<template>
    <div class="container-fluid">
      <!-- Bread-crumb-->
      <div class="block-header">
        <bread-crumb></bread-crumb>
      </div>

      <div class="row clearfix">
        <div class="col-12">
            <div class="card top_report card-top-line">
                <div class="m-2" >
                    <label class="col-12 fancy-radio mt-2">
                        <input type="radio" name="account_type" v-on:change="setAccountType('individual')" checked/>
                        <span><i></i>Individual</span>
                    </label>
                    <label class="col-12 fancy-radio mt-2">
                        <input type="radio" name="account_type" v-on:change="setAccountType('legal_entity')" />
                        <span><i></i>Legal Entity ( Company Or Organization )</span>
                    </label>
                    <label class="col-12 fancy-radio mt-2">
                        <input type="radio" name="account_type" v-on:change="setAccountType('account_type')" />
                        <span><i></i>Non-Profit</span>
                    </label>
                </div>
            </div>
        </div>
      </div>

        <div class="row clearfix"> <!-- v-if="accountType=='individual'" -->
            <div class="col-12">
                <div class="card card-top-line bank-details">
                    <div class="header">
                        <h2>General</h2>
                    </div>
                    <div class="body">
                        <div class="country-dropdown bank-details-drop">
                            <div class="form-group form-select multiselect-grp">
                                <span class="float-label">
                                    <label for="Country">Country*</label>
                                    <multiselect 
                                    v-model="country"
                                    :show-labels="false" 
                                    :options="countryList"
                                    :searchable="true" label="name" track-by="name" :custom-label="currencyFlag">
                                    <template slot="singleLabel" slot-scope="props">
                                        <span class="mr-2"
                                        :class="'flag-icon flag-icon-' + props.option.isoCode + ' fi-md fi-round '"></span>
                                        <span class="option-title">
                                        <span>{{ props.option.name }}</span>
                                        </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option-title">
                                        <span class="mr-2"
                                            :class="'flag-icon flag-icon-' + props.option.isoCode + ' fi-md fi-round '"></span>
                                        <span>{{ props.option.name }}</span>
                                        </div>
                                    </template>
                                    </multiselect>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="header d-flex align-items-center justify-content-between">
                        <h2>Bank Account Details</h2>
                        <button class="btn btn-primary" @click="account={};account.isEdit=false;$bvModal.show('add_account')" >Add New Account</button>
                    </div>
                      <ul class="list-unstyled mb-0 body bank-list pt-0">
                        <li v-for="(account, index) in bank_account"  :key="index" class="d-flex flex-column flex-md-row align-items-strech justify-content-md-between border-top py-2">
                            <ul class="list-unstyled mb-4 mb-md-0 left-list">
                                <li class="p-2 d-flex align-items-center justify-content-between justify-content-md-start">
                                    <label class="mb-0">Bank Name:</label>
                                    <p class="mb-0">{{ account.bank_name }}</p>
                                </li>
                                <li class="p-2 d-flex align-items-center justify-content-between justify-content-md-start">
                                    <label class="mb-0">Account Number:</label>
                                    <p class="mb-0">****{{ account.account_number }}</p>
                                </li>
                                <li class="p-2 d-flex align-items-center justify-content-between justify-content-md-start">
                                    <label class="mb-0">Sort Code:</label>
                                    <p class="mb-0">{{ account.sort_code }}</p>
                                </li>
                                <li class="p-2 d-flex align-items-center justify-content-between justify-content-md-start">
                                    <label class="mb-0">Currency:</label>
                                    <p class="mb-0">{{ account.currency }}</p>
                                </li>
                            </ul>
                            <div class="right-list d-flex flex-column align-items-md-end justify-content-between">
                                <div class="d-flex justify-content-center justify-content-md-end default-btn">
                                  <span v-if="account.isDefault" class="badge badge-primary font-12 p-1 rounded mx-0 mb-2">Default Account</span>
                                </div>
                                <div class="btn-grp d-flex justify-content-center justify-content-md-end">
                                    <button v-if="!account.isDefault" class="btn btn-secondary mr-2" @click="makeAsDefault(account.id)" > Make Default </button>
                                    <button class="btn btn-secondary mr-2" @click="editAccount(account)"> Edit </button>
                                    <button class="btn btn-danger" @click="deleteBankAccount(account.id)"> Delete </button>
                                </div>
                            </div>
                        </li>
                      </ul>
                </div>
            </div>
        </div>
        <!-- <div class="row clearfix" v-if="accountType=='legal_entity'">
            <h1>Test 1</h1>
        </div>
        <div class="row clearfix" v-if="accountType=='account_type'" >
            <h1>Test 2</h1>
        </div> -->
        <b-modal id="add_account" :title="account.isEdit ? 'Edit Account' : 'Add Members'" hide-footer>    
            <ValidationObserver v-slot="{ passes }">
                <form ref="form" @submit.prevent="passes(addAccount)" >
                    <ul class="list-unstyled">
                        <li>
                            <ValidationProvider name="bank_name" rules="required" v-slot="{ errors}">
                                <div class="form-group" :class="{'errors': errors.length && !account.bank_name,'success':account.bank_name}">
                                    <span class="float-label">
                                        <input type="text" autocomplete="off" v-model="account.bank_name" class="form-control" id="name" placeholder="Bank Name*">
                                        <label for="name" class="control-label">Bank Name*</label>
                                        <div class="line"></div>
                                        <i class="fa fa-times" v-if="errors.length && !account.bank_name"></i>
                                        <i class="fa fa-check" v-if="account.bank_name"></i>
                                    </span>
                                    <template v-if="apiErrors">
                                        <div v-for="(v, k) in apiErrors" :key="k">
                                            <span class="text-danger error-msg" v-if="k == 'name'">{{ v[0] | error }}</span>
                                        </div>
                                    </template>
                                </div>
                            </ValidationProvider>
                        </li>
                        <li>
                            <ValidationProvider name="account_number" rules="required" v-slot="{ errors}">
                                <div class="form-group" :class="{'errors': errors.length && !account.account_number,'success':account.account_number}">
                                    <span class="float-label">
                                        <input type="text" autocomplete="off" v-model="account.account_number" class="form-control" id="name" placeholder="Account Number*">
                                        <label for="name" class="control-label">Account Number*</label>
                                        <div class="line"></div>
                                        <i class="fa fa-times" v-if="errors.length && !account.account_number"></i>
                                        <i class="fa fa-check" v-if="account.account_number"></i>
                                    </span>
                                    <template v-if="apiErrors">
                                        <div v-for="(v, k) in apiErrors" :key="k">
                                            <span class="text-danger error-msg" v-if="k == 'name'">{{ v[0] | error }}</span>
                                        </div>
                                    </template>
                                </div>
                            </ValidationProvider>
                        </li>
                        <li>
                            
                            <ValidationProvider name="sort_code" rules="required" v-slot="{ errors}">
                                <div class="form-group" :class="{'errors': errors.length && !account.sort_code,'success':account.sort_code}">
                                    <span class="float-label">
                                        <input type="text" autocomplete="off" v-model="account.sort_code" class="form-control" id="name" placeholder="Sort Code*">
                                        <label for="name" class="control-label">Sort Code*</label>
                                        <div class="line"></div>
                                        <i class="fa fa-times" v-if="errors.length && !account.sort_code"></i>
                                        <i class="fa fa-check" v-if="account.sort_code"></i>
                                    </span>
                                    <template v-if="apiErrors">
                                        <div v-for="(v, k) in apiErrors" :key="k">
                                            <span class="text-danger error-msg" v-if="k == 'name'">{{ v[0] | error }}</span>
                                        </div>
                                    </template>
                                </div>
                            </ValidationProvider>
                        </li>
                        <li>
                            <ValidationProvider name="currency" rules="required">
                                <div class="form-group form-select multiselect-grp">
                                    <span class="float-label">
                                        <label for="Country">Currency*</label>
                                        <multiselect 
                                        v-model="account.currency"
                                        :show-labels="false" 
                                        :options="currency_options"
                                        :searchable="true" label="name" track-by="name" :custom-label="currencyFlag">
                                        <template slot="singleLabel" slot-scope="props">
                                            <span class="mr-2"
                                            :class="'flag-icon flag-icon-' + props.option.iso_code + ' fi-md fi-round '"></span>
                                            <span class="option-title">
                                            <span>{{ props.option.name }}</span>
                                            </span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option-title">
                                            <span class="mr-2"
                                                :class="'flag-icon flag-icon-' + props.option.iso_code + ' fi-md fi-round '"></span>
                                            <span>{{ props.option.name }}</span>
                                            </div>
                                        </template>
                                        </multiselect>
                                    </span>
                                </div>
                            </ValidationProvider>
                        </li>
                    </ul>
                    <div class="align-items-center d-flex flex-column justify-content-between mt-3 w-100">
                    <b-button type="submit" variant="primary btn-mw" size="lg"> {{ account.isEdit ? 'Edit Account' : 'Add Members'  }}</b-button>
                    <b-button size="lg" variant="outline-secondary mt-3 btn-mw" @click="$bvModal.hide('add_account')">Cancel
                    </b-button>
                    </div>
                </form>
            </ValidationObserver>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
    name:'BankDetails',
    components: {
        'BreadCrumb': () => import("@/components/BreadCrumb"),
        Multiselect: () => import('vue-multiselect'),
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {  
            bank_account: [
                {
                    id: 0,
                    bank_name: 'bank 1',
                    account_number: '1234',
                    sort_code: '06-03-336',
                    currency: 'USD',
                    isDefault: true
                },
                {
                    id: 1,
                    bank_name: 'bank 1',
                    account_number: '1234',
                    sort_code: '06-03-336',
                    currency: 'USD',
                    isDefault: false
                },
                {
                    id: 2,
                    bank_name: 'bank 2',
                    account_number: '1234',
                    sort_code: '06-03-336',
                    currency: 'USD',
                    isDefault: false
                },
                {
                    id: 3,
                    bank_name: 'bank 3',
                    account_number: '1234',
                    sort_code: '06-03-336',
                    currency: 'USD',
                    isDefault: false
                }
            ],
            accountType: 'individual',
            country: { name: 'United States', isoCode: 'us'},
            account: {
                bank_name: null,
                account_number: null,
                sort_code: null,
                currency: null,
                isEdit: false,
            },
            currency_options: [
                { id: 0, name: 'Ghanaian Cedi', flagClass: "flag-icon flag-icon-gh fi-xl fi-round", iso_code: "gh", isChecked: true },
                { id: 1, name: 'British Pound', flagClass: "flag-icon flag-icon-gb fi-xl fi-round", iso_code: "gb", isChecked: true },
                { id: 2, name: 'Indian Rupee', flagClass: "flag-icon flag-icon-in fi-xl fi-round", iso_code: "in", isChecked: false },
                { id: 3, name: 'CFP Franc', flagClass: "flag-icon flag-icon-fr fi-xl fi-round", iso_code: "fr", isChecked: false },
                { id: 4, name: 'United States Dollar', flagClass: "flag-icon flag-icon-us fi-xl fi-round", iso_code: "us", isChecked: true },
                { id: 5, name: 'Deutsche Mark', flagClass: "flag-icon flag-icon-de fi-xl fi-round", iso_code: "de", isChecked: false },
                { id: 6, name: 'Euro', flagClass: "flag-icon flag-icon-eu fi-xl fi-round", iso_code: "eu", isChecked: true },
                { id: 7, name: 'Russian Ruble', flagClass: "flag-icon flag-icon-ru fi-xl fi-round", iso_code: "ru", isChecked: false },
            ],
        }
    },
    methods: {
        setAccountType: function(arg){
            this.accountType=arg;
        },
        addAccount: function(){
            console.log("submit add account");
        },
        editAccount: function(accountData){
            this.account.isEdit = true;
            this.account.bank_name = accountData.bank_name,
            this.account.account_number = accountData.account_number,
            this.account.sort_code = accountData.sort_code,
            this.account.currency = { name: accountData.currency, iso_code: 'us' }
            this.$bvModal.show('add_account');
        },
        makeAsDefault: function(id){
            this.bank_account.map((data)=>{
                if(data.id == id){
                    data.isDefault = true;
                }else{
                    data.isDefault = false;
                }
            });
        },
        deleteBankAccount : function(id){
            console.log(id);
            const deleteBank = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-primary btn-lg my-3',
                    cancelButton: 'btn btn-outline-secondary btn-lg'
                },
                buttonsStyling: false
            })
            deleteBank.fire({
                title: "",
                text: "Are you sure, You want to delete this account?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.showInfo("Bank account deleted successfully..!!", "success");
                }
            })
        }
    },
    computed: {
    ...mapGetters(["countryList"]),
  },
}
</script>